import * as React from "react";
import {connect} from "react-redux";
import update from 'immutability-helper';
import {
    Alert, Button, Clearfix, Col, ControlLabel, Form, FormControl, FormGroup, Glyphicon,
    Row
} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import * as ClientsAction from "../actions/ClientActions";
import {TIER_FREE} from "../constants";
import PremiumMessage from "../components/PremiumMessage";

class AddEditClientPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            form: {
                id: undefined,
                name: "",
            },
            name: "",
            message: undefined,
            waiting: false,
        }
    }

    componentDidMount() {
        this.fetchEditClient();
        this.props.fetchClientsIfNeeded();
    }

    componentWillReceiveProps(newProps) {
        this.fetchEditClient(newProps);
        // Continue after saving
        if (this.state.waiting && !newProps.clients.createFetching) this.props.history.push("/projects")
    }

    save(event) {
        event.preventDefault();

        if (!this.state.form.name) {
            this.setState({message: {type: "danger", title: "Error", message: "Please enter a name."}});
            return;
        }
        this.setState({waiting: true, message: undefined});

        this.props.saveClient(this.state.form);
    }

    fetchEditClient(props) {
        props = props || this.props;

        if (!this.state.form.id && props.match.params) {
            const {clients} = props;
            if (clients.fetched && clients.items[props.match.params.client_id]) {
                const client = clients.items[props.match.params.client_id];

                this.setState(update(this.state, {
                    form: {$merge: client},
                    name: {$set: client.name}
                }))
            }
        }
    }

    handleChange(event) {
        this.setState({
            form: update(this.state.form, {
                [event.target.name]: {$set: event.target.value}
            })
        });
    }

    render() {

        const {message} = this.state;
        const readyToEdit = (this.props.match.params.client_id && this.state.form.id) || !this.props.match.params.client_id;

        return (readyToEdit) ? (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        {this.state.form.id ? (
                            <span>
                                <div className="visible-xs">
                                    {this.state.name}
                                    <Clearfix/>
                                </div>
                                <span className="hidden-xs">
                                    {this.state.name}
                                </span>
                            </span>
                        ) : (
                            <span>
                                Add Client
                            </span>
                        )}

                        <NavLink to={"/projects"} className="pull-right">
                            <Button>
                                <Glyphicon glyph="remove"/>
                                <span className="hidden-xs">&nbsp;Cancel</span>
                            </Button>
                        </NavLink>
                        {this.state.form.id && (
                            <NavLink to={"/projects/add/client/" + this.state.form.id} className="pull-right">
                                <Button style={{marginRight: '10px'}}>
                                    <Glyphicon glyph="plus"/>
                                    <span className="hidden-xs">&nbsp;New</span> project
                                </Button>
                            </NavLink>
                        )}
                        <Clearfix/>
                    </h1>
                </div>
                <div className="card-body">
                    {message && (
                        <Alert bsStyle={message.type} onDismiss={() => this.setState({message: null})}>
                            <h4>{message.title}</h4>
                            {message.message}
                        </Alert>
                    )}
                    {this.props.clients.createFetching ? (
                        <div>Saving...</div>
                    ) : (
                        <div>
                            {this.props.isPremium || this.state.form.id || Object.values(this.props.clients.items).length === 0 ? (
                                <Form onSubmit={this.save.bind(this)}>
                                    <FormGroup>
                                        <Row>
                                            <Col sm={4} componentClass={ControlLabel}>
                                                Client name
                                            </Col>
                                            <Col sm={8}>
                                                <FormControl componentClass="input" name="name"
                                                             value={this.state.form.name}
                                                             onChange={this.handleChange.bind(this)}/>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col sm={8} smOffset={4}>
                                                <Button bsStyle="primary" type="submit">
                                                    <Glyphicon glyph="ok"/>&nbsp;
                                                    Save
                                                </Button>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Form>
                            ) : (
                                <PremiumMessage to="add clients"/>
                            )}
                        </div>
                    )}
                </div>
            </div>
        ) : (
            <div>No clients yet</div>
        )
    }
}

export default connect(state => ({
    isPremium: state.teams && state.teams.active && state.teams.active.tier !== TIER_FREE,
    clients: state.clients,
}), dispatch => ({
    fetchClientsIfNeeded: () => dispatch(ClientsAction.fetchClientsIfNeeded()),
    saveClient: params => dispatch(ClientsAction.saveClient(params))
}))(AddEditClientPage);


// WEBPACK FOOTER //
// ./src/pages/AddEditClientPage.js